// prettier-ignore
export default "am"